import React from "react";
import { Link } from "react-router-dom";
import { BsQuote } from "react-icons/bs";

export default function HomepageReviewHeading({ id, listingAvailable = false }) {
  return <div className="homepage-review-heading d-flex align-items-center justify-content-between gap-2 mb-3">
    <h3 id={id} className="mb-0 d-flex align-items-center gap-2" style={{ minWidth: 0 }}>
      <BsQuote className="flex-shrink-0" aria-hidden="true" focusable="false" />
      <strong>รีวิวจากผู้เรียน</strong>
    </h3>
    {listingAvailable && <Link to="/course-reviews" className="btn btn-link p-0 text-decoration-none text-nowrap flex-shrink-0">
      ดูเพิ่มเติม <span aria-hidden="true">›</span>
    </Link>}
  </div>;
}
